import { cva, RecipeVariantProps } from '@allenai/varnish-panda-runtime/css';

/**
 * @remarks A label recipe
 *
 * @param size - Size of the label, values are `small`, `medium` (default), and `large`
 *
 */

const labelRecipe = cva({
    base: {
        display: 'block',
        cursor: 'default',
        color: 'text',
        _groupDisabled: {
            color: 'text.disabled',
        },
        _groupInvalid: {
            color: 'text.error',
        },
    },
    variants: {
        size: {
            small: {
                fontSize: '[12px]',
            },
            medium: {
                fontSize: 'sm',
            },
            large: {
                fontSize: 'md',
            },
        },
    },
    defaultVariants: {
        size: 'medium',
    },
});

type LabelRecipeProps = RecipeVariantProps<typeof labelRecipe>;

export { labelRecipe, labelRecipe as default };
export type { LabelRecipeProps };
